import A from "./ghl-ui.es1489.js";
const f = "^\\s*", x = "\\s*$", h = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))%\\s*", s = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))\\s*", l = "([0-9A-Fa-f])", a = "([0-9A-Fa-f]{2})", F = new RegExp(`${f}hsl\\s*\\(${s},${h},${h}\\)${x}`), C = new RegExp(`${f}hsv\\s*\\(${s},${h},${h}\\)${x}`), I = new RegExp(`${f}hsla\\s*\\(${s},${h},${h},${s}\\)${x}`), M = new RegExp(`${f}hsva\\s*\\(${s},${h},${h},${s}\\)${x}`), N = new RegExp(`${f}rgb\\s*\\(${s},${s},${s}\\)${x}`), U = new RegExp(`${f}rgba\\s*\\(${s},${s},${s},${s}\\)${x}`), m = new RegExp(`${f}#${l}${l}${l}${x}`), y = new RegExp(`${f}#${a}${a}${a}${x}`), S = new RegExp(`${f}#${l}${l}${l}${l}${x}`), E = new RegExp(`${f}#${a}${a}${a}${a}${x}`);
function u(r) {
  return parseInt(r, 16);
}
function q(r) {
  try {
    let e;
    if (e = I.exec(r))
      return [
        c(e[1]),
        i(e[5]),
        i(e[9]),
        g(e[13])
      ];
    if (e = F.exec(r))
      return [c(e[1]), i(e[5]), i(e[9]), 1];
    throw new Error(`[seemly/hsla]: Invalid color value ${r}.`);
  } catch (e) {
    throw e;
  }
}
function B(r) {
  try {
    let e;
    if (e = M.exec(r))
      return [
        c(e[1]),
        i(e[5]),
        i(e[9]),
        g(e[13])
      ];
    if (e = C.exec(r))
      return [c(e[1]), i(e[5]), i(e[9]), 1];
    throw new Error(`[seemly/hsva]: Invalid color value ${r}.`);
  } catch (e) {
    throw e;
  }
}
function p(r) {
  try {
    let e;
    if (e = y.exec(r))
      return [u(e[1]), u(e[2]), u(e[3]), 1];
    if (e = N.exec(r))
      return [$(e[1]), $(e[5]), $(e[9]), 1];
    if (e = U.exec(r))
      return [
        $(e[1]),
        $(e[5]),
        $(e[9]),
        g(e[13])
      ];
    if (e = m.exec(r))
      return [
        u(e[1] + e[1]),
        u(e[2] + e[2]),
        u(e[3] + e[3]),
        1
      ];
    if (e = E.exec(r))
      return [
        u(e[1]),
        u(e[2]),
        u(e[3]),
        g(u(e[4]) / 255)
      ];
    if (e = S.exec(r))
      return [
        u(e[1] + e[1]),
        u(e[2] + e[2]),
        u(e[3] + e[3]),
        g(u(e[4] + e[4]) / 255)
      ];
    if (r in A)
      return p(A[r]);
    throw new Error(`[seemly/rgba]: Invalid color value ${r}.`);
  } catch (e) {
    throw e;
  }
}
function j(r) {
  return r > 1 ? 1 : r < 0 ? 0 : r;
}
function z(r, e, t) {
  return `rgb(${$(r)}, ${$(e)}, ${$(t)})`;
}
function d(r, e, t, n) {
  return `rgba(${$(r)}, ${$(e)}, ${$(t)}, ${j(n)})`;
}
function v(r, e, t, n, o) {
  return $((r * e * (1 - n) + t * n) / o);
}
function G(r, e) {
  Array.isArray(r) || (r = p(r)), Array.isArray(e) || (e = p(e));
  const t = r[3], n = e[3], o = g(t + n - t * n);
  return d(v(r[0], t, e[0], n, o), v(r[1], t, e[1], n, o), v(r[2], t, e[2], n, o), o);
}
function J(r, e) {
  const [t, n, o, R = 1] = Array.isArray(r) ? r : p(r);
  return e.alpha ? d(t, n, o, e.alpha) : d(t, n, o, R);
}
function K(r, e) {
  const [t, n, o, R = 1] = Array.isArray(r) ? r : p(r), { lightness: w = 1, alpha: H = 1 } = e;
  return D([t * w, n * w, o * w, R * H]);
}
function g(r) {
  const e = Math.round(Number(r) * 100) / 100;
  return e > 1 ? 1 : e < 0 ? 0 : e;
}
function c(r) {
  const e = Math.round(Number(r));
  return e >= 360 || e < 0 ? 0 : e;
}
function $(r) {
  const e = Math.round(Number(r));
  return e > 255 ? 255 : e < 0 ? 0 : e;
}
function i(r) {
  const e = Math.round(Number(r));
  return e > 100 ? 100 : e < 0 ? 0 : e;
}
function L(r) {
  const [e, t, n] = Array.isArray(r) ? r : p(r);
  return z(e, t, n);
}
function D(r) {
  const [e, t, n] = r;
  return 3 in r ? `rgba(${$(e)}, ${$(t)}, ${$(n)}, ${g(r[3])})` : `rgba(${$(e)}, ${$(t)}, ${$(n)}, 1)`;
}
function O(r) {
  return `hsv(${c(r[0])}, ${i(r[1])}%, ${i(r[2])}%)`;
}
function Q(r) {
  const [e, t, n] = r;
  return 3 in r ? `hsva(${c(e)}, ${i(t)}%, ${i(n)}%, ${g(r[3])})` : `hsva(${c(e)}, ${i(t)}%, ${i(n)}%, 1)`;
}
function T(r) {
  return `hsl(${c(r[0])}, ${i(r[1])}%, ${i(r[2])}%)`;
}
function W(r) {
  const [e, t, n] = r;
  return 3 in r ? `hsla(${c(e)}, ${i(t)}%, ${i(n)}%, ${g(r[3])})` : `hsla(${c(e)}, ${i(t)}%, ${i(n)}%, 1)`;
}
function X(r) {
  if (typeof r == "string") {
    let n;
    if (n = y.exec(r))
      return `${n[0]}FF`;
    if (n = E.exec(r))
      return n[0];
    if (n = m.exec(r))
      return `#${n[1]}${n[1]}${n[2]}${n[2]}${n[3]}${n[3]}FF`;
    if (n = S.exec(r))
      return `#${n[1]}${n[1]}${n[2]}${n[2]}${n[3]}${n[3]}${n[4]}${n[4]}`;
    throw new Error(`[seemly/toHexString]: Invalid hex value ${r}.`);
  }
  const e = `#${r.slice(0, 3).map((n) => $(n).toString(16).toUpperCase().padStart(2, "0")).join("")}`, t = r.length === 3 ? "FF" : $(r[3] * 255).toString(16).padStart(2, "0").toUpperCase();
  return e + t;
}
function Y(r) {
  if (typeof r == "string") {
    let e;
    if (e = y.exec(r))
      return e[0];
    if (e = E.exec(r))
      return e[0].slice(0, 7);
    if (e = m.exec(r) || S.exec(r))
      return `#${e[1]}${e[1]}${e[2]}${e[2]}${e[3]}${e[3]}`;
    throw new Error(`[seemly/toHexString]: Invalid hex value ${r}.`);
  }
  return `#${r.slice(0, 3).map((e) => $(e).toString(16).toUpperCase().padStart(2, "0")).join("")}`;
}
export {
  J as changeColor,
  G as composite,
  q as hsla,
  B as hsva,
  p as rgba,
  g as roundAlpha,
  $ as roundChannel,
  c as roundDeg,
  i as roundPercent,
  K as scaleColor,
  Y as toHexString,
  X as toHexaString,
  T as toHslString,
  W as toHslaString,
  O as toHsvString,
  Q as toHsvaString,
  L as toRgbString,
  D as toRgbaString
};
